// Iter 91aj — Humi placeholder module.
// Reused by 8 module pages that are wired into the sidebar but haven't been
// built yet (Documents, Training, Surveys, Performance, Reporting, Benefits,
// Company, Add-ons). Keeps the navigation coherent while we ship the P0 tabs.

import { Sparkles } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";

export function makeHumiPlaceholder(name, description, Icon) {
  const Cmp = function HumiPlaceholder() {
    return (
      <div className="space-y-4" data-testid={`humi-placeholder-${name.replace(/\s+/g,'-').toLowerCase()}`}>
        <PageHeader
          icon={Icon ? <Icon className="h-5 w-5 text-primary" /> : <Sparkles className="h-5 w-5 text-primary" />}
          title={name}
          subtitle="Coming soon"
        />
        <Card className="p-10 text-center border-slate-200 dark:border-slate-700">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            {Icon ? <Icon className="h-6 w-6 text-primary" /> : <Sparkles className="h-6 w-6 text-primary" />}
          </div>
          <div className="text-lg font-semibold text-slate-800 dark:text-slate-100">{name} — coming soon</div>
          <div className="mx-auto mt-1 max-w-md text-sm text-slate-500 dark:text-slate-400">{description}</div>
        </Card>
      </div>
    );
  };
  Cmp.displayName = `HumiPlaceholder(${name})`;
  return Cmp;
}
